import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

class KnowledgeRequirementView extends PolylineEdge {
  getEndArrow() {
    const { model } = this.props;
    const { stroke } = model.getEdgeStyle();
    return h('path', {
      d: 'M 0 0 L -11 -5 L -11 5 Z',
      fill: 'none',
      stroke: stroke || '#722ed1',
      strokeWidth: 1.2,
      transform: 'translate(1 0)',
    });
  }
}

class KnowledgeRequirementModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);
    this.text = { ...this.text, value: '', editable: false };
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const t = getThemeStyle(this.graphModel, 'knowledgeRequirement');
    style.stroke = t.stroke || '#722ed1';
    style.strokeWidth = t.strokeWidth || 1.5;
    style.strokeDasharray = '6,4';
    return style;
  }
}

export const KnowledgeRequirement = {
  type: 'dmn:KnowledgeRequirement',
  view: KnowledgeRequirementView,
  model: KnowledgeRequirementModel,
};
